import { ROUTES } from '~shared/routes';

import { NotificationConfig, NotificationType } from './types';

export const NOTIFICATIONS_CONFIG: Record<
  NotificationType,
  NotificationConfig
> = {
  'pharmasi.protocol.MessageSent': {
    route: ROUTES.messaging,
    status: 'success',
    label: "Un patient vient d'envoyer un message",
    title: '🔥🔥 Nouveau message !',
  },
  'pharmasi.protocol.TransactionSuccess': {
    route: ROUTES.orders.root,
    status: 'success',
    label: 'Un patient vient de passer une commande',
    title: '🔥🔥 Nouvelle commande !',
  },
  'pharmasi.protocol.ReservationRegistered': {
    route: ROUTES.orders.root,
    status: 'success',
    label: 'Un patient vient de passer une commande',
    title: '🔥🔥 Nouvelle commande !',
  },
  'pharmasi.protocol.TransactionExpired': {
    route: ROUTES.orders.root,
    status: 'error',
    label: "Une commande vient d'arriver à expiration",
    title: '🔥🔥 Commande expirée !',
  },
  'pharmasi.protocol.PatientSubscriptionAdded': {
    route: ROUTES.meetings.root,
    status: 'success',
    label: 'Un patient vient de réserver un créneau',
    title: '🔥🔥 Nouveau créneau !',
  },
  'pharmasi.protocol.WaitingListPatientSubscribed': {
    route: ROUTES.waitingList.root,
    status: 'success',
    label: "Un patient vient de s'inscrire sur une liste d'attente",
    title: "🔥🔥 Nouvelle liste d'attente !",
  },
  'pharmasi.protocol.PharmacyGroupForumMessageAdded': {
    route: ROUTES.forum,
    status: 'success',
    label: 'Un pharmacien vient de poster un message dans le forum',
    title: '🔥🔥 Nouveau message forum !',
  },
};

export const NOTIFICATION_SOUND_URL =
  'https://valwin-pharma-assets.s3.eu-west-1.amazonaws.com/valwin-pharma-assets/public/assets/audio/notification.mp3';
